import React, { useState } from 'react';
import {
  Table, TableBody, TableCell, TableHead, TableRow, Paper, TableContainer, TablePagination, IconButton,
  Button,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useShoppingCartStore } from '../../hooks/useShoppingCartStore';
import { useSearcherStore } from '../../hooks/useSearcherStore';
import { readLocalStorage } from '../../toolbox/helpers/local-storage-helpers';
import { LocalStorageKey } from '../../types';

export const ProductsTableKFC: React.FC<any> = ({ products }) => {
  const [page, setPage] = useState(0); // Estado para la página actual
  const [rowsPerPage, setRowsPerPage] = useState(10); // Estado para las filas por página
  const { createShoppingCart, getShoppingCart } = useShoppingCartStore();
  const { selectedCustomer } = useSearcherStore();

  const [cardState, setCardState] = useState<any>([]);
  const userData = readLocalStorage(LocalStorageKey.USER_DATA);

  const idusersession = userData?.id;

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectProduct = (product, quantity = 1) => {

    // if(!selectedCustomer) return CustomSnackbar('error', "Asegúrese de seleccionar un cliente.");

    let card = [...cardState];
    console.log(card)
    console.log(product)
    let exits: boolean = false;
    if (product) {
        for (let i = 0; i < card.length; i++) {
            if (card[i].codesystem_product === product.codesystem_product && card[i].name_product === product.name_product) {
                // if(card[i].quantity < card[i].stock){
                //     card[i].quantity = card[i].quantity ? card[i].quantity+1 : 2
                // }
                // if(card[i].quantity === card[i].stock){
                //     alert('no hay suficiente stock');
                // }
                exits = true;
            }
        }
        if (!exits) {
            card.push({
                ...product,
                quantity: quantity,
                discount: product.discount || 0,
            });

            /* GUARDANDO EN API */
            const datacart = {
                iduser_created: idusersession,
                idcustomer: selectedCustomer?.id,
                idproduct: product?.idproduct,
                quantity: quantity,
            }
            createorupdateCartAPI(datacart);
        }

        /* PARA OBTENER CONTADOR DEL CARRITO */
        getShoppingCartApi();
    }
}

const getShoppingCartApi = async () => {
  const datacart = {
      iduser_created: idusersession,
      idcustomer: selectedCustomer?.id,
      page: "",
      perPage: ""
  }
  const response = await getShoppingCart(datacart)
  if (response && response.length > 0) {
      const { detail, ...otherfields } = response[0];
      setCardState(detail || []);
  } else {
      setCardState([]);
      return false;
  }
}

const createorupdateCartAPI = async (data) => {
  try {
      
      const response = await createShoppingCart(data);
      console.log(response);
      if (response) {
         
      } else {
         
          return false;
      }
  } catch (error) {
     
  }
}

  return (
    <Paper elevation={3} sx={{ width: '100%', margin: '20px 0', borderRadius: '10px' }}>
      <TableContainer>
        <Table aria-label="products table">
          <TableHead sx={{ backgroundColor: '#69ABC3' }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Código</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Nombre</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Marca</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Modelo</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Línea</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}>Precio</TableCell>
              <TableCell sx={{ fontWeight: 'bold', color: '#fff' }}></TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {products.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((product: any) => (
              <TableRow key={product.codesystem_product}>
                <TableCell>{product.codesystem_product}</TableCell>
                <TableCell>{product.name_product}</TableCell>
                {/* <TableCell>{product.category_product}</TableCell> */}
                {/* <TableCell>{product.subcategory_product?.name || 'Sin subcategoría'}</TableCell> */}
                <TableCell>
                  {Array.from(
                    new Set(
                      product.relationProductAttributes.map(
                        (attr: any) => attr.parent_attribute?.name
                      )
                    )
                  )
                    .filter(Boolean) // Esto elimina los valores null o undefined
                    .join(', ')}
                </TableCell>

                <TableCell>
                  {product.relationProductAttributes
                    .map((attr: any) => attr.child_attribute?.name)
                    .filter(Boolean) // Esto elimina los valores null o undefined
                    .join(', ')}
                </TableCell>

                <TableCell>{product.specificsubcategory_product?.name || 'Sin línea'}</TableCell>
                <TableCell>{product.price_product ? `$${product.price_product}` : 'N/A'}</TableCell>
                <TableCell>
                <Button
                                      onClick={() => handleSelectProduct(product)} 
                                      sx={{ 
                                        borderRadius: '20px', 
                                        fontSize: '10px', 
                                        backgroundColor: '#EBA058', 
                                        color: '#fff', 
                                        height: '30px', 
                                        padding: '0 15px', 
                                        margin: '5px', 
                                        transition: 'transform 0.3s ease', // Animación para el botón
                                        '&:hover': { 
                                          transform: 'scale(1.1)', // Crece cuando se pasa el cursor
                                          backgroundColor: '#d9924e', // Color más oscuro en hover
                                        }
                                      }}
                                    >
                                      Seleccionar
                                    </Button>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginación */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={products.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelRowsPerPage="Filas por página"
      />
    </Paper>
  );
};
